// src/data/Experiences.js

export const experiences = [
  {
    id: 1,
    name: "Trineo de Perros – Mountain Mushing",
    category: "Adventure",
    duration: "2.5 horas",
    departures: ["9:00 am", "10:30 am", "1:30 pm", "3:00 pm"],
    pricing: [
      { type: "1 o 2 personas", price: 629 },
      { type: "2 adultos + 1 niño pequeño", price: 729 }
    ],
    currency: "CAD",
    taxIncluded: false,
    images: ["/static/images/Trineo_Perros.jpeg"],
    notes: [
      "Precio por trineo, no por persona",
      "Máximo 2 adultos por trineo"
    ]
  },
  {
    id: 2,
    name: "Motos de Nieve – Wilderness Adventure Tour",
    category: "Adventure",
    duration: "2 horas (1.25 h de manejo)",
    departures: ["9:00 am", "11:00 am", "1:00 pm", "2:30 pm", "4:00 pm"],
    pricing: [
      { type: "Piloto solo", price: 269 },
      { type: "Pasajero adicional", price: 229 },
      { type: "Seguro obligatorio", price: 35 }
    ],
    currency: "CAD",
    taxIncluded: false,
    images: ["/static/images/Motos_nieve.jpeg"],
    notes: [
      "Edad mínima para conducir: 19 años con licencia válida"
    ]
  },
  {
    id: 3,
    name: "Heliski – Whistler Heli-Skiing (3 Descensos)",
    category: "Ski / Snowboard",
    duration: "Medio día",
    departures: null,
    pricing: [
      { type: "Por persona", priceFrom: 1720 }
    ],
    currency: "CAD",
    taxIncluded: false,
    images: ["/static/images/Heliski.jpeg"],
    notes: [
      "Requiere condición física y nivel adecuado"
    ]
  },
  {
    id: 4,
    name: "Tirolesa – Eagle Tour (Invierno)",
    category: "Adventure",
    duration: "2 horas",
    departures: null,
    pricing: [
      { type: "Adultos (13+)", price: 159.99 },
      { type: "Niños (6–12)", price: 129.99 }
    ],
    currency: "CAD",
    taxIncluded: false,
    images: ["/static/images/Tirolesa.jpeg"],
    notes: [
      "Tarifas pueden variar del 15 de diciembre al 4 de enero",
      "Peso mínimo: 75 lb",
      "Peso máximo: 275 lb"
    ]
  },
  {
    id: 5,
    name: "Tour en Helicóptero – The Summit",
    category: "Sightseeing",
    duration: "24 minutos",
    departures: null,
    pricing: [
      { type: "Por persona", price: 279 }
    ],
    passengers: { min: 2, max: 5 },
    currency: "CAD",
    taxIncluded: false,
    images: ["/static/images/Tour_helicoptero.jpeg"],
    notes: ["Sujeto a clima"]
  },
  {
    id: 6,
    name: "Vallea Lumina – Experiencia Nocturna",
    category: "Family / Light Adventure",
    duration: "45–60 minutos",
    distance: "1.5 km",
    departures: null,
    pricing: [
      { type: "Adultos y niños (6+)", price: 54.99 },
      { type: "Niños menores de 6 años", price: 0 }
    ],
    currency: "CAD",
    taxIncluded: false,
    images: ["/static/images/Vallea_Lumina.jpeg"],
    notes: [
      "Más de 200 escalones",
      "Incluye transporte desde y hacia el hotel (según horario disponible)"
    ]
  },
  {
    id: 7,
    name: "Snowshoeing – Raven Trail Tour",
    category: "Adventure / Hiking",
    duration: "2.5 horas",
    departures: ["9:00 am", "10:30 am", "1:00 pm"],
    pricing: [
      { type: "Adultos", price: 149 },
      { type: "Niños (12 o menos)", price: 109 }
    ],
    currency: "CAD",
    taxIncluded: false,
    images: ["/static/images/Snowshoeing.jpeg"],
    notes: ["Ideal para todas las edades"]
  },
  {
    id: 8,
    name: "Cena en la Montaña – Cabaña Remota",
    category: "Dining / Exclusive",
    duration: "3.5 horas",
    departures: null,
    includes: ["Cena gourmet de 4 tiempos"],
    pricing: [
      { type: "Snowcoach (pasajero)", price: 349 },
      { type: "Conduciendo snowmobile propio", price: 389 }
    ],
    currency: "CAD",
    taxIncluded: false,
    images: ["/static/images/Cena_Montana.jpeg"],
    notes: [
      "Accesible por snowmobile o snowcat",
      "Experiencia privada ideal para familias o celebraciones"
    ]
  }
];